import LocalImages from "assets/images/local-images";
import ConfirmButton from "features/shared/components/buttons/ConfirmButton.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import { FC, useEffect } from "react";
import NativeBridge from "services/native-bridge/native-bridge";
import { useAppStore } from "store/store";

import OutageContainer from "./styles/OutageContainer.styled";
import useOutageInfo from "features/shared/hooks/useOutageInfo";

const Outage: FC = () => {
  const locale = useAppStore((state) => state.locale);

  const outageInfo = useOutageInfo();

  const title = outageInfo.getTitle(locale);
  const description = outageInfo.getDescription(locale);
  const linkTitle = outageInfo.getButtonTitle(locale);
  const redirectUrl = outageInfo.getRedirectUrl(locale);

  useEffect(() => {
    NativeBridge.shared.closeFlow("outage");
  }, []);

  return (
    <OutageContainer>
      <img alt="outage icon" src={LocalImages.shared.images.icons.notFound} />
      {title ? <TertiaryHeader>{title}</TertiaryHeader> : null}
      <Summary>{description}</Summary>
      {redirectUrl !== undefined && !NativeBridge.shared.isEmbedded ? (
        <a href={redirectUrl}>
          <ConfirmButton>{linkTitle}</ConfirmButton>
        </a>
      ) : null}
    </OutageContainer>
  );
};

export default Outage;
